<template>
  <!--
    뉴젠 공용 아바타.
    사진 URL(src)이 있으면 사진을, 로드 실패(사진 없는 사용자는 서버가 404)하거나 src가 비면
    이름 기반 색상 이니셜로 폴백한다. 색상/글자색은 _ng-avatar.scss 의 .gpro-avatar--cN 에서 단일 정의.
    사진 URL 은 뉴젠 조회 쿼리에서 ?fallback=none 을 붙여 내려주므로, 사진 없을 때 no_photo.jpg 대신 404 가 떨어진다.
  -->
  <el-avatar
    :size="size"
    :shape="shape"
    :src="photoSrc"
    :class="['gpro-avatar', colorClass]"
    :style="
      fontSize
        ? {
            fontSize: typeof fontSize === 'number' ? fontSize + 'px' : fontSize,
          }
        : null
    "
    >{{ initial }}</el-avatar
  >
</template>

<script>
export default {
  name: "GproAvatar",
  props: {
    // 표시 이름(이니셜/색상 해시의 기준)
    name: { type: String, default: "" },
    // 프로필 사진 URL. 없거나 로드 실패하면 이니셜로 폴백
    src: { type: String, default: "" },
    // 아바타 지름(px)
    size: { type: [Number, String], default: 24 },
    // 이니셜 글자 크기 오버라이드(옵션). 숫자면 px 로 해석
    fontSize: { type: [Number, String], default: null },
    // 모양. 사람=circle(기본), 조직=square(둥근 네모)
    shape: { type: String, default: "circle" },
  },
  computed: {
    // 빈 문자열이면 el-avatar 가 바로 슬롯(이니셜)을 그리도록 undefined 로
    photoSrc() {
      return this.src ? this.src : undefined;
    },
    initial() {
      return this.name ? this.name.charAt(0) : "";
    },
    colorClass() {
      return this.$util.avatarColorClass(this.name);
    },
  },
};
</script>
